/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type OnboardingDtoStatus = typeof OnboardingDtoStatus[keyof typeof OnboardingDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnboardingDtoStatus = {
  ONGOING: 'ONGOING',
  PERSONAL_COMPLETED: 'PERSONAL_COMPLETED',
  CONTRACT_CREATED: 'CONTRACT_CREATED',
} as const;
